export const getRetirementGap = (
	desiredIncome: number,
	statePension: number,
): number => Math.max(0, desiredIncome - statePension);
